import { render, staticRenderFns } from "./dialog-changename.vue?vue&type=template&id=5aadc9c6&"
import script from "./dialog-changename.vue?vue&type=script&lang=js&"
export * from "./dialog-changename.vue?vue&type=script&lang=js&"
import style0 from "./dialog-changename.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports